export const templateProfile = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Priya Rajan — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:264px minmax(0,1fr) 300px; height:100vh; width:100%; max-width:none; margin:0;}

  /* ============ LEFT SIDEBAR (shared shell) ============ */
  .sidebar{padding:26px 18px; display:flex; flex-direction:column; height:100vh; border-right:1px solid rgba(44,44,42,0.07);}
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}
  .nav-item{display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%; font-size:15px; font-weight:500; color:#6B5F58; transition:background .15s, color .15s;}
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:20px;}
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .post-btn{margin:18px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px; font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px; transition:transform .15s, box-shadow .15s;}
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .sidebar-spacer{flex:1;}
  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px; background:rgba(216,90,48,0.06);}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600;}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER — PROFILE ============ */
  .profile-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}

  .banner{
    height:168px; background:linear-gradient(120deg,#D85A30,#B23D18); position:relative;
  }
  .banner-edit{
    position:absolute; bottom:12px; right:16px; background:rgba(44,44,42,0.4); color:#fff; font-size:11.5px; font-weight:600;
    padding:6px 13px; border-radius:20px; display:flex; align-items:center; gap:6px; backdrop-filter:blur(4px);
  }

  .identity-block{padding:0 32px; position:relative;}
  .avatar-xl{
    width:96px; height:96px; border-radius:50%; background:#9FE1CB; border:4px solid #F1E4DE;
    margin-top:-48px; position:relative;
  }
  .founder-ring{position:absolute; inset:-4px; border-radius:50%; border:2.5px solid var(--gold); pointer-events:none;}
  .id-top-row{display:flex; align-items:flex-end; justify-content:space-between; margin-top:-26px;}
  .edit-profile-btn{
    background:#fff; border:1.5px solid rgba(44,44,42,0.12); color:var(--charcoal); font-size:13px; font-weight:700;
    padding:9px 20px; border-radius:30px; display:flex; align-items:center; gap:7px;
  }

  .id-name-row{display:flex; align-items:center; gap:9px; margin-top:14px;}
  .id-name{font-family:var(--serif); font-size:25px;}
  .founder-badge{
    background:rgba(250,199,117,0.22); color:#8A5A00; font-size:11px; font-weight:700; padding:4px 11px;
    border-radius:20px; display:flex; align-items:center; gap:5px;
  }
  .id-handle{font-size:13.5px; color:#9A8C84; margin-top:2px;}
  .id-bio{font-size:14px; color:#5A4F49; line-height:1.55; max-width:480px; margin-top:12px;}
  .id-meta-row{display:flex; gap:18px; margin-top:14px; flex-wrap:wrap;}
  .id-meta{display:flex; align-items:center; gap:6px; font-size:12.5px; color:#9A8C84;}

  .stats-row{display:grid; grid-template-columns:repeat(5,1fr); margin-top:24px; border-top:1px solid rgba(44,44,42,0.07); border-bottom:1px solid rgba(44,44,42,0.07);}
  .stat-cell{padding:16px 0; text-align:center; border-right:1px solid rgba(44,44,42,0.07);}
  .stat-cell:last-child{border-right:none;}
  .stat-num{font-family:var(--serif); font-size:21px; color:var(--charcoal);}
  .stat-num.accent{color:var(--spice-deep);}
  .stat-label{font-size:11px; color:#9A8C84; margin-top:2px;}

  .profile-tabs{display:flex; gap:6px; padding:14px 26px 0; border-bottom:1px solid rgba(44,44,42,0.07);}
  .ptab{padding:12px 16px; font-size:13.5px; font-weight:600; color:#9A8C84; position:relative; display:flex; align-items:center; gap:6px;}
  .ptab.active{color:var(--spice-deep);}
  .ptab.active::after{content:''; position:absolute; bottom:-1px; left:14px; right:14px; height:2.5px; background:var(--spice); border-radius:2px;}
  .ptab-count{background:rgba(44,44,42,0.06); color:#6B5F58; font-size:10.5px; font-weight:700; padding:1px 7px; border-radius:20px;}
  .ptab.active .ptab-count{background:rgba(216,90,48,0.14); color:var(--spice-deep);}

  .grid-content{padding:22px 26px 60px;}
  .recipe-grid{display:grid; grid-template-columns:repeat(3,1fr); gap:12px;}
  .grid-tile{
    aspect-ratio:1; border-radius:16px; position:relative; overflow:hidden; display:flex; align-items:center; justify-content:center;
    cursor:pointer;
  }
  .grid-tile .tile-overlay{
    position:absolute; bottom:0; left:0; right:0; padding:10px; background:linear-gradient(transparent, rgba(0,0,0,0.55));
    opacity:0; transition:opacity .2s;
  }
  .grid-tile:hover .tile-overlay{opacity:1;}
  .tile-overlay p{color:#fff; font-size:11.5px; font-weight:600; font-family:var(--sans);}
  .tile-made{
    position:absolute; top:8px; right:8px; background:rgba(0,0,0,0.45); color:#fff; font-size:10px; font-weight:700;
    padding:3px 8px; border-radius:20px;
  }
  .tile-winner{
    position:absolute; top:8px; left:8px; background:var(--gold); color:#5A3A00; font-size:13px;
    width:24px; height:24px; border-radius:50%; display:flex; align-items:center; justify-content:center;
  }
  .add-tile{
    border:2px dashed rgba(44,44,42,0.15); background:transparent; color:var(--spice); font-size:26px;
  }

  /* challenges tab content */
  .challenge-summary-row{display:grid; grid-template-columns:repeat(4,1fr); gap:10px; margin-bottom:20px;}
  .csum{background:#fff; border-radius:14px; padding:14px; text-align:center; border:1px solid rgba(44,44,42,0.06);}
  .csum b{display:block; font-family:var(--serif); font-size:19px; color:var(--spice-deep);}
  .csum span{font-size:10.5px; color:#9A8C84;}
  .chal-card{background:#fff; border-radius:18px; padding:16px; margin-bottom:12px; border-left:3px solid var(--herb);}
  .chal-card.live{border-left-color:var(--spice);}
  .chal-top{display:flex; align-items:center; justify-content:space-between; margin-bottom:8px;}
  .chal-status{font-size:10.5px; font-weight:700; padding:3px 9px; border-radius:20px;}
  .chal-status.live{background:#FCEBEB; color:#A32D2D;}
  .chal-status.ended{background:#E1F5EE; color:#085041;}
  .chal-title{font-family:var(--serif); font-size:15px; margin-bottom:6px;}
  .chal-meta{font-size:11.5px; color:#9A8C84; margin-bottom:10px;}
  .winner-strip{
    background:rgba(250,199,117,0.12); border:1px solid rgba(250,199,117,0.35); border-radius:10px; padding:8px 10px;
    display:flex; align-items:center; gap:8px; font-size:11.5px; color:#8A5A00;
  }

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:28px;}
  .rail-head{display:flex; align-items:center; justify-content:space-between; margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}

  .trophy-card{background:var(--charcoal); border-radius:18px; padding:18px; position:relative; overflow:hidden; margin-bottom:14px;}
  .trophy-card::before{content:''; position:absolute; top:-50px; right:-40px; width:120px; height:120px; background:radial-gradient(circle, rgba(250,199,117,0.3), transparent 70%);}
  .trophy-card .tc-label{font-size:10.5px; letter-spacing:0.06em; text-transform:uppercase; color:var(--gold); margin-bottom:8px; position:relative;}
  .trophy-card .tc-title{font-family:var(--serif); font-size:16px; color:var(--cream); line-height:1.3; margin-bottom:4px; position:relative;}
  .trophy-card .tc-sub{font-size:11.5px; color:rgba(250,236,231,0.6); position:relative;}

  .win-mini{display:flex; align-items:center; gap:10px; padding:9px 0; border-bottom:1px solid rgba(44,44,42,0.06);}
  .win-mini:last-child{border-bottom:none;}
  .win-mini-icon{width:30px; height:30px; border-radius:50%; background:rgba(250,199,117,0.2); display:flex; align-items:center; justify-content:center; font-size:13px; flex-shrink:0;}
  .win-mini-name{font-size:12.5px; font-weight:600;}
  .win-mini-meta{font-size:11px; color:#9A8C84;}

  .mutual-card{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06);}
  .mutual-avatars{display:flex; margin-bottom:10px;}
  .mutual-avatars span{width:30px; height:30px; border-radius:50%; border:2px solid #fff; margin-left:-9px;}
  .mutual-avatars span:first-child{margin-left:0;}
  .mutual-card p{font-size:12px; color:#6B5F58; line-height:1.5;}
  .mutual-card p b{color:var(--charcoal);}

  .cuisine-tag-cloud{display:flex; flex-wrap:wrap; gap:6px;}
  .cuisine-tag-cloud span{background:#fff; border:1px solid rgba(44,44,42,0.08); color:#6B5F58; font-size:11.5px; padding:5px 11px; border-radius:20px;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .pm-name, .pm-handle{display:none;}
    .nav-item{justify-content:center;} .nav-badge{display:none;} .post-btn{padding:13px;} .profile-mini{justify-content:center;}
  }
  @media (max-width:900px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>
    <nav>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item active" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>
    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>
    <div class="sidebar-spacer"></div>
    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div><div class="pm-name">Priya Rajan</div><div class="pm-handle">@priyacooks</div></div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER — PROFILE ================= -->
  <main class="profile-col">

    <div class="banner">
      <button class="banner-edit">📷 Edit cover</button>
    </div>

    <div class="identity-block">
      <div class="id-top-row">
        <div class="avatar-xl" style="background:#9FE1CB;">
          <div class="founder-ring"></div>
        </div>
        <button class="edit-profile-btn">✎ Edit profile</button>
      </div>

      <div class="id-name-row">
        <span class="id-name">Priya Rajan</span>
        <span class="founder-badge">🏅 Founding Creator #004</span>
      </div>
      <p class="id-handle">@priyacooks</p>
      <p class="id-bio">South Asian home cook. Dal obsessed. Every recipe is an invitation. 🍛</p>

      <div class="id-meta-row">
        <span class="id-meta">📍 New York, NY</span>
        <span class="id-meta">🍛 South Asian · Healthy</span>
        <span class="id-meta">📅 Joined March 2026</span>
      </div>

      <div class="stats-row">
        <div class="stat-cell"><div class="stat-num">48</div><div class="stat-label">Recipes</div></div>
        <div class="stat-cell"><div class="stat-num">1.8k</div><div class="stat-label">Followers</div></div>
        <div class="stat-cell"><div class="stat-num">312</div><div class="stat-label">Following</div></div>
        <div class="stat-cell"><div class="stat-num accent">214</div><div class="stat-label">Made its</div></div>
        <div class="stat-cell"><div class="stat-num accent">8</div><div class="stat-label">Challenges</div></div>
      </div>
    </div>

    <div class="profile-tabs">
      <div class="ptab active" data-tab="recipes">Recipes <span class="ptab-count">48</span></div>
      <div class="ptab" data-tab="madeit">Made it <span class="ptab-count">214</span></div>
      <div class="ptab" data-tab="challenges">Challenges <span class="ptab-count">8</span></div>
      <div class="ptab" data-tab="saved">Saved <span class="ptab-count">36</span></div>
    </div>

    <div class="grid-content">

      <!-- RECIPES GRID -->
      <div class="tab-panel" id="panel-recipes">
        <div class="recipe-grid">
          <div class="grid-tile" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
            <svg width="36" height="36" viewBox="0 0 100 100"><ellipse cx="50" cy="55" rx="28" ry="8" fill="#085041" opacity="0.4"/><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/><circle cx="58" cy="40" r="8" fill="#fff" opacity="0.7"/></svg>
            <span class="tile-made">89 made</span>
            <div class="tile-overlay"><p>Dal Tadka with ghee</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
            <svg width="36" height="36" viewBox="0 0 100 100"><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.85"/></svg>
            <span class="tile-winner">🏆</span>
            <div class="tile-overlay"><p>Paneer Tikka Masala</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
            <svg width="36" height="36" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg>
            <span class="tile-made">34 made</span>
            <div class="tile-overlay"><p>Cardamom rice pudding</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
            <svg width="36" height="36" viewBox="0 0 100 100"><circle cx="50" cy="50" r="22" fill="#fff" opacity="0.6"/></svg>
            <span class="tile-made">61 made</span>
            <div class="tile-overlay"><p>Spiced lentil soup</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
            <svg width="36" height="36" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
            <span class="tile-made">27 made</span>
            <div class="tile-overlay"><p>One-pan breakfast</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#F5C4B3,#D85A30);">
            <svg width="36" height="36" viewBox="0 0 100 100"><ellipse cx="50" cy="60" rx="30" ry="10" fill="#fff" opacity="0.5"/></svg>
            <span class="tile-made">52 made</span>
            <div class="tile-overlay"><p>Mango chutney glaze</p></div>
          </div>
          <div class="grid-tile add-tile">+</div>
        </div>
      </div>

      <!-- MADE IT GRID (hidden by default) -->
      <div class="tab-panel" id="panel-madeit" style="display:none;">
        <div class="recipe-grid">
          <div class="grid-tile" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
            <svg width="36" height="36" viewBox="0 0 100 100"><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.85"/></svg>
            <div class="tile-overlay"><p>🔥 Maria's Cacio e Pepe</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
            <svg width="36" height="36" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
            <div class="tile-overlay"><p>🔄 James's brisket, my twist</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
            <svg width="36" height="36" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg>
            <div class="tile-overlay"><p>🔥 Sofia's sourdough</p></div>
          </div>
        </div>
      </div>

      <!-- CHALLENGES PANEL -->
      <div class="tab-panel" id="panel-challenges" style="display:none;">
        <div class="challenge-summary-row">
          <div class="csum"><b>8</b><span>Total entered</span></div>
          <div class="csum"><b>1</b><span>Live now</span></div>
          <div class="csum"><b>5</b><span>Ended</span></div>
          <div class="csum"><b>3</b><span>Won 🏆</span></div>
        </div>

        <div class="chal-card live">
          <div class="chal-top"><span class="chal-title">Pasta with 3 ingredients only</span><span class="chal-status live">LIVE</span></div>
          <p class="chal-meta">Hosted by Maria K. · 47h remaining</p>
        </div>

        <div class="chal-card">
          <div class="chal-top"><span class="chal-title">One-pan BBQ flatbread</span><span class="chal-status ended">ENDED</span></div>
          <p class="chal-meta">Hosted by James L. · Ended 4 days ago</p>
          <div class="winner-strip">🏆 You won this challenge — smoked paprika twist</div>
        </div>

        <div class="chal-card">
          <div class="chal-top"><span class="chal-title">Bake it under 30 minutes</span><span class="chal-status ended">ENDED</span></div>
          <p class="chal-meta">Hosted by Sofia M. · Ended 2 weeks ago</p>
        </div>
      </div>

      <!-- SAVED PANEL -->
      <div class="tab-panel" id="panel-saved" style="display:none;">
        <div class="recipe-grid">
          <div class="grid-tile" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
            <svg width="36" height="36" viewBox="0 0 100 100"><circle cx="50" cy="50" r="22" fill="#fff" opacity="0.6"/></svg>
            <div class="tile-overlay"><p>Smoked mapo tofu</p></div>
          </div>
          <div class="grid-tile" style="background:linear-gradient(150deg,#F5C4B3,#D85A30);">
            <svg width="36" height="36" viewBox="0 0 100 100"><ellipse cx="50" cy="60" rx="30" ry="10" fill="#fff" opacity="0.5"/></svg>
            <div class="tile-overlay"><p>Rosemary sourdough</p></div>
          </div>
        </div>
      </div>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="trophy-card">
        <p class="tc-label">Trophy case</p>
        <p class="tc-title">3 challenge wins</p>
        <p class="tc-sub">Most recent: BBQ flatbread, 4 days ago</p>
      </div>
      <div class="win-mini">
        <div class="win-mini-icon">🏆</div>
        <div><div class="win-mini-name">One-pan BBQ flatbread</div><div class="win-mini-meta">vs. 52 entries · by James L.</div></div>
      </div>
      <div class="win-mini">
        <div class="win-mini-icon">🏆</div>
        <div><div class="win-mini-name">Weeknight curry, 20 min</div><div class="win-mini-meta">vs. 31 entries · by Aisha K.</div></div>
      </div>
      <div class="win-mini">
        <div class="win-mini-icon">🏆</div>
        <div><div class="win-mini-name">Breakfast on a budget</div><div class="win-mini-meta">vs. 19 entries · by Tom R.</div></div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Cuisines</h3></div>
      <div class="cuisine-tag-cloud">
        <span>🍛 South Asian</span><span>🥗 Healthy</span><span>🫔 Mediterranean</span><span>🌶️ Spicy</span>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Mutual circle</h3></div>
      <div class="mutual-card">
        <div class="mutual-avatars">
          <span style="background:#F0997B;"></span>
          <span style="background:#AFA9EC;"></span>
          <span style="background:#FAC775;"></span>
        </div>
        <p><b>Maria K., James L.</b> and 6 others you follow also follow Priya</p>
      </div>
    </div>

  </aside>

</div>

<script>
  document.querySelectorAll('.ptab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.ptab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      document.querySelectorAll('.tab-panel').forEach(p => p.style.display = 'none');
      document.getElementById('panel-' + tab.dataset.tab).style.display = 'block';
    });
  });
</script>

</body>
</html>

`;
